import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../api';
import { scaVerifyRedirectFailure } from '../actions';
import { SCA_START_ENROLLMENT, SCA_START_RECIPIENT_ENROLLMENT } from '../constants';
import * as scaLogic from '../logic/sca';

export function* scaStartEnrollmentSaga(action) {
  try {
    const { returnUrl } = action.payload || {};

    if (!returnUrl) {
      yield put(
        scaVerifyRedirectFailure({
          message: 'Missing return URL for SCA enrollment.',
          result: {},
        }),
      );
      return;
    }

    const scaEnrollUrl = yield call(api.scaEnroll, { sca_return_url: returnUrl });

    if (typeof scaEnrollUrl === 'string' && scaEnrollUrl) {
      if (typeof window.location.replace === 'function') {
        window.location.replace(scaEnrollUrl); // preferred for SCA
      } else {
        window.location.href = scaEnrollUrl;
      }
    } else {
      yield put(
        scaVerifyRedirectFailure({
          message: 'Failed to start a new SCA session. Please try again.',
          result: {},
        }),
      );
    }
  } catch (err) {
    const message =
      err?.response?.data?.message ||
      err?.response?.data ||
      err?.message ||
      'An error occurred while initiating the SCA process.';

    const useMessage =
      message === 'User does not have a mangopay id'
        ? 'Your account is missing required information to begin verification.'
        : message;

    yield put(
      scaVerifyRedirectFailure({
        message: useMessage,
        result: {},
      }),
    );
  }
}

export function* scaStartRecipientEnrollmentSaga(action) {
  try {
    const { returnUrl, actionUrl, rid } = action.payload || {};

    if (!actionUrl) {
      yield put(
        scaVerifyRedirectFailure({
          message: 'Missing verification URL.',
          result: {},
        }),
      );
      return;
    }

    // LEGACY: keep storing rid if provided (no longer required by new flow)
    if (rid) yield call(scaLogic.setStoredRid, rid);

    // Fallback to current location if returnUrl not provided
    const fallbackReturnUrl = (() => {
      try {
        return `${window.location.origin}${window.location.pathname}${window.location.search}`;
      } catch {
        return '/payout'; // last-resort safe default
      }
    })();

    const raw = returnUrl || fallbackReturnUrl;
    const ret = scaLogic.sanitizeReturnUrl(raw);
    const scaEnrollUrl = yield call(scaLogic.appendReturnUrl, actionUrl, ret);

    if (typeof scaEnrollUrl === 'string' && scaEnrollUrl) {
      if (typeof window.location.replace === 'function') {
        window.location.replace(scaEnrollUrl); // preferred for SCA
      } else {
        window.location.href = scaEnrollUrl;
      }
      return;
    }

    yield put(
      scaVerifyRedirectFailure({
        message: 'Invalid or expired verification link.',
        result: {},
      }),
    );
  } catch (err) {
    const message =
      err?.response?.data?.message ||
      err?.response?.data ||
      err?.message ||
      'An error occurred while processing your verification link.';

    yield put(
      scaVerifyRedirectFailure({
        message,
        result: {},
      }),
    );
  }
}

export function* watchSCAStartEnrollment() {
  yield takeLatest(SCA_START_ENROLLMENT, scaStartEnrollmentSaga);
}

export function* watchSCAStartRecipientEnrollment() {
  yield takeLatest(SCA_START_RECIPIENT_ENROLLMENT, scaStartRecipientEnrollmentSaga);
}

export default [watchSCAStartEnrollment(), watchSCAStartRecipientEnrollment()];
